import Geometry from '../geometry/Geometry';

/**
 * Helper class to create a quad
 *
 * @class
 * @memberof PIXI
 */
export default class Quad extends Geometry
{
    /**
     * just a quad
     */
    constructor()
    {
        super();

        this.addAttribute('aVertexPosition', [
            0, 0,
            1, 0,
            1, 1,
            0, 1,
        ])
            .addIndex([0, 1, 3, 2]);
    }
}
